// @ts-nocheck
import Cookies from "js-cookie";
import { io } from "socket.io-client";

let socket: SocketIOClient;

function createSocket() {
  const token = Cookies.get("whoxa_web_token");
  return io(import.meta.env.VITE_BASE_URL || "", {
    path: "/socket",
    auth: { token },
    transports: ["websocket", "polling"],
    upgrade: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    timeout: 20000,
  });
}

export const initiateSocketConnection = () => {
  if (!socket) {
    socket = createSocket();
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
  }
};

export const socketInstance = () => {
  if (!socket) {
    socket = createSocket();
  }
  return socket;
};
